export const SET_SELECTED_DATES = 'templates/hotel/searchParameters/selectDates/SET_SELECTED_DATES';
export const SET_PRICE_DAYS = 'templates/hotel/searchParameters/selectDates/SET_PRICE_DAYS';
export const SET_PRICE_DAYS_FETCHING = 'templates/hotel/searchParameters/selectDates/SET_PRICE_DAYS_FETCHING';
export const SET_PRICE_DAYS_CALENDAR_INFO = 'templates/hotel/searchParameters/selectDates/SET_PRICE_DAYS_CALENDAR_INFO';
